module.exports = __webpack_public_path__ + "static/img/no_data.e2f85f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no_data.png
// module id = TZJk
// module chunks = 1